import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

type LoadingModalProps = {
  isLoading: boolean;
};

const LoadingModal = ({ isLoading }: LoadingModalProps) => {
  return (
    <Backdrop
      sx={{
        color: "#fff",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        flexDirection: "column",
        background: "rgba(0, 0, 0, 0.80)",
      }}
      open={isLoading}
    >
      <CircularProgress size={60} thickness={4} />
      <Typography fontSize="16" fontWeight="500" sx={{ mt: 2 }}>
        Loading...
      </Typography>
    </Backdrop>
  );
};

export default LoadingModal;
